import React from "react";
import { TspStatCard } from "../../../components/primitives";
import TSP_ICONS from "../../../utils/tspIcons";

const TONES = ["primary", "amber", "blue", "green", "purple"];

export default function StatCardsRow({ stats }) {
  return (
    <div className="tsp-stat-cards-row">
      {stats.map((stat, index) => (
        <TspStatCard key={stat.key} icon={TSP_ICONS[stat.icon]} value={stat.value} label={stat.label} tone={TONES[index % TONES.length]} />
      ))}
    </div>
  );
}
